import { AfterViewInit, Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SimpleDialogData } from '../../interfaces/simple-dialog-data.interface';
import { SimpleDialogService } from '../../services/simple-dialog.service';
import { SimpleDataDialogComponent } from '../simple-data-dialog/simple-data-dialog.component';

/**
 * Simple data list component
 */
@Component({
  selector: 'simple-data-list',
  templateUrl: './simple-data-list.component.html',
  styleUrls: ['./simple-data-list.component.scss'],
})
export class SimpleDataListComponent implements OnInit, AfterViewInit {
  /**
   * Source
   */
  @Input()
  source: any[];

  /**
   * Source service
   */
  @Input()
  sourceService: any;

  /**
   * Instance
   */
  @Input()
  instance: any;

  /**
   * Primary key
   */
  @Input()
  primaryKey: any;

  /**
   * Data source
   */
  dataSource: MatTableDataSource<any>;

  /**
   * Keys of entity
   */
  keysOfEntity: string[];

  /**
   * Id of source selected
   */
  idSourceSelected: any;

  /**
   * Instance of source
   */
  instanceOfSource: any;

  /**
   * Sort
   */
  @ViewChild(MatSort) sort: MatSort;

  /**
   * Constructor
   *
   * @param injector Injector
   * @param dialog MatDialog
   * @param snackBar MatSnackBar
   * @param simpleDialogService SimpleDialogService
   */
  constructor(
    private injector: Injector,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private simpleDialogService: SimpleDialogService
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<any>(this.source);
    if (this.source && this.source[0]) {
      this.instanceOfSource = this.source[0];
    } else {
      this.instanceOfSource = this.instance;
    }

    if (!this.instanceOfSource) {
      this.showError('There is not source to get data in this component. You should add an array of data or an empty instance.');
    }

    this.keysOfEntity = Object.keys(this.instanceOfSource);
    this.keysOfEntity.push('actions');

    if (!this.sourceService) {
      try {
        this.sourceService = this.injector.get(`${this.instanceOfSource.constructor.name}Service`);
        // TODO: Use new injector = this.sourceService = this.injector.get<string>(new InjectionToken(`Service`));
      } catch (e) {
        console.log(e);
        this.showError(`${this.instanceOfSource.constructor.name}: There is no service for this kind of data or the service
         is not in providers array in the module.`);
      }
    }
  }

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  /**
   * Create new instance
   */
  create(): void {
    const newElementSource = new (this.instanceOfSource.constructor as { new () })();

    this.manageDialog(newElementSource);
  }

  /**
   * Edit instance
   *
   * @param elementSource Instance of element
   */
  edit(elementSource: any): void {
    this.idSourceSelected = elementSource[this.primaryKey];
    this.manageDialog({ ...elementSource });
  }

  /**
   * Manage dialog
   *
   * @param data Data for dialog
   */
  manageDialog(data: any): void {
    const dialogRef = this.dialog.open(SimpleDataDialogComponent, {
      data: {
        elementSource: data,
        primaryKey: this.primaryKey,
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        if (response.isUpdate) {
          this.sourceService.update(this.idSourceSelected, response.elementSource).subscribe(() => this.loadSource());
        } else {
          this.sourceService.create(response.elementSource).subscribe(() => this.loadSource());
        }
      }
    });
  }

  /**
   * Load list of instance
   */
  loadSource(): void {
    this.sourceService.list().subscribe((source: any) => {
      this.source = source;
      this.dataSource = new MatTableDataSource<any>(source);
    });
  }

  /**
   * Remove instance
   *
   * @param elementSource Instance of element
   */
  remove(elementSource: any): void {
    this.idSourceSelected = elementSource[this.primaryKey];

    const data: SimpleDialogData = {
      title: 'Warning!',
      message: `Do you want remove ${elementSource.constructor.name} ${this.idSourceSelected}?`,
      rightButtonText: 'Yes',
    };

    this.simpleDialogService.open(data).subscribe((response) => {
      if (response) {
        this.sourceService.delete(this.idSourceSelected).subscribe(() => this.loadSource());
      }
    });
  }

  /**
   * Show error
   *
   * @param message Error message
   */
  showError(message: string): void {
    this.snackBar.open(message, 'I will fix it!', {
      duration: -1,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
